package tta.destinigo.talktoastro.feature_profile.edit_profile.di

import tta.destinigo.talktoastro.feature_profile.edit_profile.data.ProfileDetails

sealed class EditProfileState {
    data class OnError(val message: String) : EditProfileState()
    data class OnLoading(val isLoading: Boolean) : EditProfileState()
    data class onSuccess(val data: ProfileDetails) : EditProfileState()
}